export const stopEntityNavigation = (event) => {
    if (event?.preventDefault) event.preventDefault();
    if (event?.stopPropagation) event.stopPropagation();
    return false;
};

const getEntityLinkProps = ({ canView, href, onClick, target }) => {
    if (!canView) {
        return {
            href: undefined,
            onClick: stopEntityNavigation,
            target: undefined,
        };
    }

    return {
        href,
        onClick,
        target,
    };
};

const getGuardedEntityClickHandler = (canView, onClick) => {
    return (event, ...args) => {
        if (!canView) return stopEntityNavigation(event);
        if (!onClick) return true;
        return onClick(event, ...args);
    };
};
